module.exports = __webpack_public_path__ + "img/white.0f8d2878.jpg";